import request from '@/util/request'


export const flowList = (data) => request.post('/api/flowList', data);  //配置审批流列表

export const flowAdd = (data) => request.post('/api/flowAdd', data);  //配置审批流添加

export const flowEdit = (data) => request.post('/api/flowEdit', data);  //配置审批流编辑

export const flowDel = (data) => request.post('/api/flowDel', data);  //配置审批流删除